import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './styles/globals.css';
import App from './App';
import { initSentry } from './shared/lib/sentry';
import { CrashFallback } from './shared/components/CrashFallback';

initSentry();

createRoot(document.getElementById('root')!).render(
  <Sentry.ErrorBoundary fallback={<CrashFallback />}>
    <App />
  </Sentry.ErrorBoundary>,
);
